export default __webpack_public_path__ + "assets/icons/checked.3392e687.svg";